import { domainLocales } from 'domainLocales'
import { ENV } from 'interfaces/constants'

export const _communityHref = (relativePath: string) => {
  return `/community${relativePath}`
}

export const getWebsiteUrlApi = (locale: string) => {
  return `https://${domainLocales[locale]}`
}

export const getCurrentBaseUrl = (locale: string, IS_MARRY_BABY = true) => {
  if (typeof window !== 'undefined') return window.location.origin
  const { NEXT_PUBLIC_DEPLOY_ENV } = ENV
  const isStaging = NEXT_PUBLIC_DEPLOY_ENV === 'staging'
  const isDev = NEXT_PUBLIC_DEPLOY_ENV === 'development'
  return isDev
    ? 'http://localhost:3000'
    : `https://${
        isStaging
          ? IS_MARRY_BABY
            ? 'fe.'
            : 'discover.'
          : IS_MARRY_BABY
          ? 'www.'
          : ''
      }${domainLocales[locale]}`
}
